<template>
  <v-container fluid>
    <v-card class="mb-3" v-show="!loading">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Cadastro de Fornecedor</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text @click="$router.push('/fornecedores')" :disabled="salvando">Cancelar</v-btn>
          <v-btn text :disabled="!form_valid" :loading="salvando" @click="salvar">Salvar</v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-form ref="form_valid" v-model="form_valid" lazy-validation>
        <v-container fluid>
          <h3>Fornecedor</h3>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Razão Social *"
                ref="razao_social"
                v-model="fornecedor.razao_social"
                autofocus
                @keypress.native.enter="$refs.nome_fantasia.focus()"
                :rules="regras.razao_social"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                label="Nome Fantasia *"
                ref="nome_fantasia"
                v-model="fornecedor.nome_fantasia"
                @keypress.native.enter="$refs.cnpj.focus()"
                :rules="regras.nome_fantasia"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                label="CNPJ *"
                ref="cnpj"
                v-model="fornecedor.cnpj"
                @keypress.native.enter="$refs.ie.focus()"
                :rules="regras.cnpj"
                mask="##.###.###/####-##"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field label="Inscrição Estadual" ref="ie" v-model="fornecedor.ie" @keypress.native.enter="$refs.rua.focus()"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Rua *"
                ref="rua"
                v-model="fornecedor.endereco.rua"
                @keypress.native.enter="$refs.numero.focus()"
                :rules="regras.rua"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                label="Número *"
                ref="numero"
                v-model="fornecedor.endereco.numero"
                @keypress.native.enter="$refs.complemento.focus()"
                :rules="regras.numero"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Complemento"
                ref="complemento"
                v-model="fornecedor.endereco.complemento"
                @keypress.native.enter="$refs.bairro.focus()"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Bairro *"
                ref="bairro"
                v-model="fornecedor.endereco.bairro"
                @keypress.native.enter="$refs.estado_id.focus()"
                :rules="regras.bairro"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm6>
              <v-autocomplete
                v-model="fornecedor.endereco.estado_id"
                ref="estado_id"
                :items="estados"
                label="Estado *"
                @change="getCidadesLoja"
                @keypress.native.enter="$refs.cidade_id.focus()"
                :rules="regras.estado"
              />
            </v-flex>
            <v-flex sm6>
              <v-autocomplete
                v-model="fornecedor.endereco.cidade_id"
                ref="cidade_id"
                :items="cidades"
                label="Cidade *"
                @keypress.native.enter="$refs.cep.focus()"
                :rules="regras.cidade"
                :loading="load_cidade"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm2>
              <v-text-field
                label="CEP *"
                ref="cep"
                v-model="fornecedor.endereco.cep"
                @keypress.native.enter="$refs.telefone.focus()"
                :rules="regras.cep"
                mask="##.###-###"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Telefone"
                ref="telefone"
                v-model="fornecedor.endereco.telefone"
                @keypress.native.enter="$refs.celular.focus()"
                mask="(##) ####-####"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Celular"
                ref="celular"
                v-model="fornecedor.endereco.celular"
                @keypress.native.enter="$refs.email.focus()"
                mask="(##) #####-####"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                label="Email"
                ref="email"
                v-model="fornecedor.endereco.email"
                :rules="regras.email"
                @keypress.native.enter="$refs.usuario.focus()"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <h3>Usuário</h3>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Usuário *"
                ref="usuario"
                v-model="fornecedor.user.email"
                :rules="regras.usuario"
                @keypress.native.enter="salvar"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 v-show="!fornecedor.id">
              <v-text-field label="Senha" ref="senha" v-model="senha" @keypress.native.enter="salvar" disabled readonly></v-text-field>
            </v-flex>
            <!-- <v-flex sm4 v-show="!fornecedor.id">
              <v-text-field label="Senha" ref="senha" v-model="fornecedor.user.senha" :rules="regras.senha" @keypress.native.enter="$refs.confirmar_senha.focus()"></v-text-field>
            </v-flex>
            <v-flex sm4 v-show="!fornecedor.id">
              <v-text-field label="Confirmar Senha" ref="confirmar_senha" v-model="confirmar_senha" :rules="regras.confirmar_senha" @keypress.native.enter="salvar"></v-text-field>
            </v-flex> -->
          </v-layout>
          <span style="color: darkgray">Os campos com * são obrigatórios</span>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import validadores from "@/mixins/validadores-mixin";
import ServiceFornecedores from "@/services/fornecedores.js";

export default {
  name: "FornecedoresForm",
  mixins: [validadores],
  data() {
    return {
      form_valid: false,
      loading: false,
      salvando: false,
      load_cidade: false,
      fornecedor: {
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        user: {
          email: "",
        },
      },
      user: {},
      regras: {
        razao_social: [(value) => !!value || "Campo obrigatório"],
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [(value) => !!value || "Campo obrigatório", (value) => this.validarCNPJ(value) || "CNPJ Inválido"],
        rua: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        email: [(value) => (value ? this.validarEmail(value) || "Email Inválido" : true)],
        usuario: [(value) => !!value || "Campo obrigatório"],
        /* senha: [ 
          value => !!value || 'Campo obrigatório',
          value => value == this.confirmar_senha || 'As senhas devem ser iguais'
        ],
        confirmar_senha: [ 
          value => !!value || 'Campo obrigatório',
          value => value == this.fornecedor.user.senha || 'As senhas devem ser iguais'
        ], */
      },
      estados: Services.estados(),
      cidades: [],
      senha: "123456",
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.params.fornecedor_id) {
      this.editar(this.$route.params.fornecedor_id);
    }
  },
  methods: {
    async salvar() {
      if (this.$refs.form_valid.validate()) {
        try {
          this.salvando = true;

          let response = "";
          if (this.$route.params.fornecedor_id) {
            response = await ServiceFornecedores.atualizar(this.fornecedor);
          } else {
            response = await ServiceFornecedores.salvar(this.fornecedor);
          }

          if (response.data.status == 1) {
            this.$eventbus.notificar(response.data.msg);
            this.$router.push("/fornecedores");
          } else {
            this.$eventbus.erro(response.data.msg);
          }
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar fornecedor");
        } finally {
          this.salvando = false;
        }
      }
    },
    async editar(fornecedor_id) {
      try {
        this.loading = true;
        let fornecedor = await ServiceFornecedores.editar(fornecedor_id);
        this.fornecedor = fornecedor.data.fornecedor;
        this.getCidadesLoja();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao editar fornecedor");
      } finally {
        this.loading = false;
      }
    },
    async getCidadesLoja() {
      try {
        this.load_cidade = true;
        let response = await Services.cidades(this.fornecedor.endereco.estado_id);
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar cidades");
      } finally {
        this.load_cidade = false;
      }
    },
  },
};
</script>

<style></style>
